<div class="row">
	<div class="col-5">
		<ng-container>
			<jhi-variables-table [variables]="addtlDesignVariables"
								 [showInputVariablesColumn]="false"
								 [variableTypeIds]="[VariableTypeEnum.EXPERIMENTAL_DESIGN]"
								 [showReorderButtons]="false"
								 [preventAddSystemVariables]="studyEditorContext.hasGeneratedDesign()"
								 [showAddButton]="studyEditorContext.germplasmListExists && hasAddOptionalVariablePermission()"
								 [showDeleteButton]="studyEditorContext.germplasmListExists && principal.hasAnyAuthorityDirect(MOD_OPTIONAL_DESIGN_VARS_PERMISSIONS) && items.length > 0"
								 (onAddEvent)="addVariable($event, VariableTypeEnum.EXPERIMENTAL_DESIGN)"
								 (onRemoveEvent)="detachOrDeleteFilesIfAny($event, VariableTypeEnum.EXPERIMENTAL_DESIGN)"
								 (onVariableSelectModalClosed)="onVariableSelectModalClosed()"
			></jhi-variables-table>
		</ng-container>
	</div>
	<div class="col-7">
		<div class="row pt-3">
			<div class="col d-flex justify-content-start align-items-center">
				<label>{{ 'study-editor.study-dataset.select-environment' | translate}}</label>
				<div class="col-8 ms-2">
					<ng-select [items]="experimentalDesignContext.datasetInstances" [ngModel]="selectedEnvironment" (ngModelChange)="onEnvironmentChange($event)" [clearable]="false">
						<ng-template ng-label-tmp let-item="item">
							@if (item.instanceNumber) {
								{{ item.instanceNumber }} -
							}
							{{ item.locationName }}
						</ng-template>
						<ng-template ng-option-tmp let-item="item" let-index="index">
							@if (item.instanceNumber) {
								{{ item.instanceNumber }} -
							}
							{{ item.locationName }}
						</ng-template>
					</ng-select>
				</div>
			</div>
		</div>
		<div class="row pt-3">
			<div class="col-8 d-flex justify-content-start align-items-center">
				<label class="col-auto" jhiTranslate="global.records.per.page">Records per page:</label>
				<div class="col-2 ms-2">
					<select name="exp-design-table_length" class="form-select form-select-sm"
							[(ngModel)]="pageSize"
							(change)="onPageSizeChange($event)">
						<option value="50">50</option>
						<option value="75">75</option>
						<option value="100">100</option>
					</select>
				</div>
				<div class="col-3">
					<button class="btn btn-sm btn-outline-info ms-2" (click)="clearFilters()"><i class="fa fa-filter-circle-xmark me-1`"></i>
						<span jhiTranslate="study-editor.clear.filter">Clear Filter</span></button>
				</div>
			</div>
			<div class="col-4 d-flex justify-content-end align-items-center">
				<div ngbDropdown container="body" class="d-inline-block me-1" placement="bottom-right">
					<button class="btn btn-info btn-sm" id="columnsDropdown" ngbDropdownToggle>
						<span translate="study-editor.experiment-design.additional-details.actions"></span>
					</button>
					<div ngbDropdownMenu aria-labelledby="columnsDropdown">
						<button *ngIf="showImportOptionalDetailsAction()"  class="dropdown-item" type="submit"
								(click)="exportOptionalDetailsTemplate()" >
							<span translate="study-editor.experiment-design.additional-details.export"></span>
						</button>
						<button *ngIf="showImportOptionalDetailsAction()"  class="dropdown-item" type="submit"
								(click)="importOptionalDetails()" >
							<span translate="study-editor.experiment-design.additional-details.import"></span>
						</button>
					</div>
				</div>
				<jhi-column-selector [showGroupToggle]="false"
									 [displayedColumns]="displayedColumns"
									 [columnDataService]="columnDataService"
									 (reset)="onColumnSelectorReset()"></jhi-column-selector>
			</div>
		</div>
		<!-- Data Table -->
		<div class="table-responsive mt-3">
			<div class="custom-scroll-style" style="max-height: 500px; overflow-y: auto; overflow-x: auto;">
				<table id="study-instances-table"
					   class="table table-striped table-bordered table-curved table-editable">
					<thead class="sticky-header">
					<tr cdkDropList cdkDropListOrientation="horizontal" (cdkDropListDropped)="dropColumn($event)">
						@for (column of displayedColumns; track trackColumnsById(column)) {
							@if (column.selected) {
								<th [ngClass]="getColumnClass(column)" cdkDrag cdkDragHandle>
									{{ column.displayName || column.name }}

									@if (column.termId !== CHECKBOX && column.termId !== STATIC_COLUMN_FILES) {
										<span class="cursor-pointer ms-1"
											  #p="ngbPopover"
											  (click)="showColumnFilterPopover(column, p)"
											  [autoClose]="'outside'"
											  [ngbPopover]="columnFilterTemplate"
											  container="body"
											  [placement]="['bottom', 'right', 'auto']"
											  triggers="manual">
												<i class="fa fa-filter ps-1" [ngClass]="{'filtering-by': column.isFiltered}"></i>
											@if (column.sortingAsc !== undefined && column.sortingAsc !== null) {
												<i class="ps-1 fa fa-icon-active"
												   [ngClass]="{'fa-sort-asc': column.sortingAsc, 'fa-sort-desc': !column.sortingAsc}">
													</i>
											}
											</span>
									}
								</th>
							}
						}
					</tr>
					</thead>
					<tbody>
						@for (entry of items; track trackRowsById(entry); let row = $index) {
							<tr>
								@for (column of displayedColumns; track column; let col = $index) {
									<td *ngIf="column.selected && column.visible" (click)="selectEditableCell(entry, row, col)"
										[class.selected]="editingCell?.row === row && editingCell?.col === col && isColumnEditable(column)"
										[class.number-cell]="variableDataTypeIs(column, DataTypeEnum.NUMERIC)"
										[class.date-cell]="variableDataTypeIs(column, DataTypeEnum.DATE)"
										[class.categorical-cell]="variableDataTypeIs(column, DataTypeEnum.CATEGORICAL)"
										[class.error-cell]="getCellData(row, col)?.hasError"
										[ngClass]="getCellClass(entry, column)">
										@if (editingCell?.row === row && editingCell?.col === col && isColumnEditable(column)) {
											<jhi-study-inline-editor
												[observationVariable]="column"
												[cellData]="getCellData(row, col)"
												(click)="$event.stopPropagation()"
												(onBlur)="onCellBlur(entry, column, row, col)"
												(onKeyDown)="onCellKeyDown($event, entry, column, row, col)"
												[isCategoricalDescriptionView]="isCategoricalDescriptionView"
												[categoricalBindBy]="'name'"
												[enableCustomCategoricalItem]="true"
												[categoricalDropdownPosition]="row <= 4 ? 'bottom' : 'auto'"
											>
											</jhi-study-inline-editor>
										} @else {
											@if (entry.variables[column.name]) {
												<truncate-span [textInput]="getCellValue(entry, column) | categoricalDisplayValue:column:'both':true" [showCopyButton]="false"></truncate-span>
											}
										}
									</td>
								}
							</tr>
						}
					</tbody>
				</table>
			</div>
		</div>

		<div class="d-flex justify-content-between align-items-center mt-3">

			<div>
				@if (numberOfItems !== numberOfFilteredItems) {
					<span name="pageDescription" class="text-muted" jhiTranslate="study-editor.pagination.entry-count"
						  [translateValues]="{param1: (currentPage - 1) * pageSize + 1, param2: Math.min(currentPage * pageSize, numberOfFilteredItems), param3: numberOfFilteredItems}"></span>
					<span class="text-muted" jhiTranslate="study-editor.pagination.entry-total-count" [translateValues]="{param: numberOfItems}"></span>
				} @else {
					<span name="pageDescription" class="text-muted" jhiTranslate="study-editor.pagination.entry-count"
						  [translateValues]="{param1: (currentPage - 1) * pageSize + 1, param2: Math.min(currentPage * pageSize, numberOfFilteredItems), param3: numberOfItems}"></span>
				}
			</div>
			<div>
				<div class="d-inline-block ms-3">
					<ngb-pagination
						[collectionSize]="numberOfFilteredItems || numberOfItems"
						[(page)]="currentPage"
						[pageSize]="pageSize"
						[maxSize]="10"
						[ellipses]="true"
						[boundaryLinks]="true"
						[rotate]="true"
						(pageChange)="onPageChange($event)">
					</ngb-pagination>
				</div>
				<div class="d-inline-block ms-3">
					<label for="goToPage" class="me-2" jhiTranslate="study-editor.pagination.go-to">Go to page:</label>
					<input id="goToPage" type="number" class="form-control d-inline-block w-auto"
						   [min]="1" [max]="Math.ceil((numberOfFilteredItems || numberOfItems) / pageSize)"
						   [(ngModel)]="currentPage"
						   (change)="onPageChange(currentPage); $event.preventDefault()"/>
				</div>
			</div>
		</div>
	</div>
</div>

<!-- Column Filter Template -->
<ng-template #columnFilterTemplate>
	<div class="column-filter">
		<!-- Sorting Buttons -->
		<div class="btn-group w-100" role="group" *ngIf="columnDataForFilter.enableFilterSorting">
			<button (click)="sortColumn(columnDataForFilter,true)" class="btn btn-o"
					[ngClass]="columnDataForFilter.sortingAsc === true ? 'btn-info' : 'btn-outline-secondary'">
				<i class="fa fa-sort-alpha-asc fw-bold fs-6"></i>
			</button>
			<button (click)="sortColumn(columnDataForFilter,false)" class="btn"
					[ngClass]="columnDataForFilter.sortingAsc === false ? 'btn-info' : 'btn-outline-secondary'">
				<i class="fa fa-sort-alpha-desc fw-bold fs-6"></i>
			</button>
		</div>
		<!-- Regular Input Filter -->
		<div *ngIf="columnDataForFilter.dataTypeCode !== 'D'" class="mt-2">
			<input class="form-control"
				   [(ngModel)]="columnDataForFilter.query"
				   placeholder="{{ 'common.filter.value' | translate }}"
                   [title]="columnDataForFilter.possibleValues?.length ? ('study-editor.study-dataset.no.values.filter.title' | translate) : ''">

			<!-- Filter Options List -->
			<ul class="list-group mt-3" *ngIf="columnDataForFilter.possibleValues">
				<li class="list-group-item" *ngIf="!columnDataForFilter.query">
					<div class="form-check">
						<input type="checkbox"
							   class="form-check-input"
							   [(ngModel)]="columnDataForFilter.isSelectAll"
							   (change)="filterSelectAll(columnDataForFilter, columnDataForFilter.isSelectAll)">
						<label class="form-check-label" jhiTranslate="global.select.all.items">Select all</label>
					</div>
				</li>
				<li *ngFor="let option of columnDataForFilter.possibleValues | orderBy:'name' | filter:columnDataForFilter.query:'name'"
					class="list-group-item">
					<div class="form-check">
						<input type="checkbox"
							   class="form-check-input"
							   [(ngModel)]="option.isSelectedInFilters"
							   (change)="filterSelectOption(option.isSelectedInFilters)">
						<label class="form-check-label">
							{{ isCategoricalDescriptionView ? option.displayDescription : option.displayValue }}
						</label>
					</div>
				</li>
			</ul>
		</div>

		<!-- Date Filter -->
		<div *ngIf="columnDataForFilter.dataTypeCode === 'D'" class="mt-3">
			<input class="form-control"
				   [(ngModel)]="columnDataForFilter.query"
				   ngbDatepicker="dp"
				   placeholder="{{ 'common.filter.value' | translate }}">
			<div class="mt-3">
				<ngb-datepicker #dp
								[(ngModel)]="columnDataForFilter.query"
								class="well well-sm"
								(click)="$event.stopPropagation()">
				</ngb-datepicker>
			</div>
		</div>

		<!-- Action Buttons -->
		<div class="mt-3">
			<div class="d-flex justify-content-around">
				<div>
					<button class="btn btn-info ms-2"
							(click)="filterByColumn(columnDataForFilter)"
							title="{{ 'global.apply.all.filter' | translate }}" jhiTranslate="apply">
						Apply
					</button>
					<button class="btn btn-secondary ms-2"
							(click)="resetFilterByColumn(columnDataForFilter)"
							title="{{ 'global.reset.filter' | translate }}" jhiTranslate="reset">
						Reset
					</button>
				</div>
			</div>
		</div>
	</div>

</ng-template>
